<div class="claim-notification-data">
    <div class="claim-notification-data__label">
        {{ label }}
        <span class="claim-notification-data__value">
            <ng-content></ng-content>
        </span>
    </div>
    <div class="claim-notification-data__tooltip" *ngIf="tooltip">
        <a href="#" class="link-secondary" [insTooltip]="tooltip" orientation="right">Wijzig</a>
    </div>
</div>
